import {
   GET_DISPOSITION_PENALTY_FLAG_SAVE,
   SET_DISPOSITION_PENALTY_FLAG_SAVE
} from "./DispositionPenalityFlagType"

const getDispositionPenaltyFlagSave = (payload?: any) => ({
    type: GET_DISPOSITION_PENALTY_FLAG_SAVE,
    payload
});

const setDispositionPenaltyFlagSave = (isDispositionPenaltyFlagSaved: any) => ({
    type: SET_DISPOSITION_PENALTY_FLAG_SAVE,
    isDispositionPenaltyFlagSaved: isDispositionPenaltyFlagSaved
});


export {
    getDispositionPenaltyFlagSave,
    setDispositionPenaltyFlagSave
}
